<template>
    <div class="m-shop-detail">
        <div class="shop-view" :class="'shop-' + $route.params.sid">

            <div class="other-nav">
                <div class="shop-1" v-if="$route.params.sid == 2" @click="see_offer(1);"></div>
                <div class="shop-2" v-if="$route.params.sid == 1" @click="see_offer(2);"></div>
            </div>
            
            <div class="shop-pannel">
                <div class="shop-banner" :class="'banner-' +  $route.params.sid ">
                    <div class="title"></div>

                    <div class="ticket-list">
                        <div class="offer-list" v-if="shop_ticket.length && $store.state.userinfo.zid">
                            <div class="ticket-item" v-for="(item,index) in shop_ticket" :key="index">
                                <div class="t-title">
                                    <div class="type" v-if="item.type == 1">{{ item.value }}</div>
                                    <div class="type" v-if="item.type == 2">{{ item.value }}折</div>
                                    <div class="slogen">{{ item.slogen }}</div>
                                </div>

                                <div class="t-detail">
                                    <h5 v-if="item.type == 1">店铺满减券</h5>
                                    <h5 v-if="item.type == 2">店铺折扣券</h5>
                                    <div class="content"><span v-if="item.full > 0">满{{ item.full }}可用，</span>最多可抵扣{{ item.maxAmt }}</div>
                                    <div class="time">{{ $global.activityTime }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="offer-list" v-if="!$store.state.userinfo.zid">
                            <div class="ticket-item" v-for="(item,index) in default_ticket[$route.params.sid]" :key="index">
                                <div class="t-title">
                                    <div class="type" v-if="item.type == 1">{{ item.value }}</div>
                                    <div class="type" v-if="item.type == 2">{{ item.value }}折</div>
                                    <div class="slogen">{{ item.slogen }}</div>
                                </div>

                                <div class="t-detail">
                                    <h5 v-if="item.type == 1">店铺满减券</h5>
                                    <h5 v-if="item.type == 2">店铺折扣券</h5>
                                    <div class="content"><span v-if="item.full > 0">满{{ item.full }}可用，</span>最多可抵扣{{ item.maxAmt }}</div>
                                    <div class="time">{{ $global.activityTime }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="ticket-item" v-for="(item,index) in tickets_list[$route.params.sid]" :key="index">
                            <div class="t-title">
                                <div class="type">{{ item.type }}</div>
                                <div class="slogen">{{ item.slogen }}</div>
                            </div>

                            <div class="t-detail">
                                <h5 v-if="item.type == '满减'">店铺满减券</h5>
                                <h5 v-if="item.type == '折扣'">店铺折扣券</h5>
                                <div class="content">{{ item.text }}</div>
                                <div class="time">{{ $global.activityTime }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="notice" v-if="$route.params.sid == 1">折扣券与满减券可叠加使用</div>
                </div>

                <div class="shop-list">
                    <div class="list-pannel" v-if="shop_list.length">
                        <div class="list-item" v-for="(item,index) in shop_list" :key="item.sid + index">
                            <h5>{{ item.giftName }}*{{ item.sendNum }}</h5>

                            <div class="discount"><em class="tag"></em>{{ shop_dic[item.sid].discount }}</div>

                            <div class="goods-detail">
                                <div class="goods-wrapper">
                                    <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                </div>  
                            </div>

                            <div class="low">最低价<em class="icon-m3b"></em><span class="p-now">{{ item.minPrice }}</span><span class="p-before">{{ item.price }}</span></div>
                            <div class="banner" v-bind:data-sid="'1'">{{ shop_dic[item.sid].name }}</div>

                            <div class="u-btn apply" @click="call_cut(item)"></div>
                        </div>
                    </div>
                    <div class="list-pannel" v-else>
                        <div class="empty">
                            <p>暂时没有其他商品了哦~</p>
                        </div>
                    </div>                    
                </div>
                
                <rec-view></rec-view>
            </div>

            
        </div>
    </div>
</template>

<script>
import shop_group from '@/components/shopgroup.js'

export default {
    data (){
        return {
            sid : 0,//暂时废弃         
            time : this.$global.activityTime,
            shop_group : shop_group.list,
            shop_dic : shop_group.shop_dic,            
            shop_list : [],
            shop_ticket : [],
            tickets_list : {
                1 : [{ type : '满减', slogen : '2000-200', text : '布小蛮杂货铺内商品每满2000-200' }],
                2 : [{ type : '满减', slogen : '5000-600', text : '张莺莺重工厂内商品每满5000-600' }],
            },
            default_ticket : {
                1 : [
                    {
                        "ticketName": "店铺折扣券",
                        "type": 2,
                        "shopId": 1,
                        "value": 8,
                        "maxAmt": 2000,
                        "full": 8000,
                    },                    
                ],
                2 : [],
            },
        }
    },
    mounted(){
        this.init();
    },
    methods : {
        init(){
            this.get_goods_list(this.$route.params.sid);

            //if(this.$route.params.sid != 1)return;
            this.shop_ticket = this.$store.state.ticket.filter((ele) => {
                return ele.state == 1 && ele.shopId == this.$route.params.sid;
            })

            if(!this.$store.state.login && this.$route.params.sid == 1){
                this.shop_ticket = [{
                    "ticketId": "2403131038032165270",
                    "ticketName": "店铺折扣券",
                    "type": 2,
                    "shopId": 1,
                    "value": 8,
                    "maxAmt": 2000,
                    "full": 8000,
                    "state": 1,
                    "getTime": "2024-03-13 10:38:03",
                    "activeTime": "2024-03-13 10:38:03",
                    "useTime": null,
                    "expireTime": null
                }]
            }            
        },
        get_goods_list (sid){
            this.$get(ajax_url_map.goods_list,{
                success : (data) => {
                    this.shop_list = data.data;
                }
            },{
                sid : this.$route.params.sid,
            })
        },
        get_shop_ticket(){

        },
        see_offer (sid){
            //this.$router.push({ name: 'detail', params: { sid: sid }});
            
            this.$router.push({ path: `/detail/${sid}` });
            this.init();
        },        
        call_cut(item){

            if(!item.giftId){
                throw new Error('缺少商品ID');
            }

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            this.$post(ajax_url_map.add_basket,{
                success : (data) => {
                    //let shareTxt = data.data.koudai + this.$store.state.userinfo.nickName + '阿斗测试分享' + data.data.shopName + data.data.price + ' ' + data.data.url;
                    let shareTxt = this.$global.share_format({...data.data,nickName : this.$store.state.userinfo.nickName});
                    this.$copy_modal({ shareTxt : shareTxt });
                    this.get_goods_list(this.sid);
                },
                error : (data) => {
                    this.$toast(data.message);
                }                
            },{
                id : item.id,
            })
        },
    },   
}
</script>

<style lang="scss" scoped>
.shop-view{
    position: relative;
    width: 750px;
    padding-top: 490px;
    // padding-bottom: 200px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: top center;        


    &.shop-1{
        background-image: url(~@/assets/images/detail/banner-1.png);   
    }

    &.shop-2{
        background-image: url(~@/assets/images/detail/banner-2.png);   
    }
    
    a{
        display: block;
        width: 100%;
        height: 100%;
    }
}

.other-nav{
    position: absolute;
    right: 30px;
    top: 300px;

    .shop-1{
        width: 150px;
        height: 152px;
        background-image: url(~@/assets/images/detail/nav-1.png);        
    }

    .shop-2{
        width: 153px;
        height: 166px;
        background-image: url(~@/assets/images/detail/nav-2.png);        
    }    
}

.shop-pannel{
    width: 750px;
    min-height: 600px;
    padding-bottom: 200px;
    margin: 0 auto;
    background-image: url(~@/assets/images/task/bg-task.png);
    background-repeat: repeat-y;
    
    .shop-list{
        margin-bottom: 24px;
    }
}

.shop-banner{
    width: 750px;
    margin: 0 auto;
    padding-top: 35px;
    padding-bottom: 20px;
    box-sizing: border-box;

    .title{
        width: 584px;
        height: 95px;
        margin: 0 auto 24px;
    }

    .notice{
        margin-top: 20px;
        text-align: center;
        color: #ffdc4e;
    }

    &.banner-1{
        max-height: 534px;
        background-image: url(~@/assets/images/detail/shop-top_1.png);
        
        .title{
            background-image: url(~@/assets/images/detail/shop-name_1.png);
        }
    }

    &.banner-2{
        height: 336px;
        background-image: url(~@/assets/images/detail/shop-top_2.png);
        // max-height: 534px;
        // background-image: url(~@/assets/images/detail/shop-top_1.png);        
        
        .title{
            background-image: url(~@/assets/images/detail/shop-name_2.png);
        }        
    }

}

.ticket-list{
    .ticket-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 691px;
        height: 150px;
        margin: 0 auto 10px;
        padding: 0 70px 0 90px;
        background-image: url(~@/assets/images/detail/ticket.png);

        .t-title{
            width: 134px;
            text-align: center;
        }

        .type{
            font-size: 60px;
            font-weight: 700;
            color: #b23700;
        }

        .slogen{
            color: #b23700;
        }

        .t-detail{
            width: 330px;
            color: #864b31;
            text-align: center;

            h5{
                font-size: 24px;
                margin-bottom: 12px;
            }

            .content{
                font-size: 20px;
            }

            .time{
                font-size: 20px;
            }
        }
    }
}

.shop-list{
    .list-pannel{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 18px 20px 0;

        .empty{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 420px;
            margin-top: 40px;
            padding: 0 30px;
            font-size: 40px;
            font-weight: 700;       
            color: #aa754f;        
            text-align: center;
        }

        .list-item{
            position: relative;
            width: 331px;
            height: 552px;
            padding-top: 42px;
            background-image: url(~@/assets/images/shop/item-pannel.png);
            text-align: center;

            .icon-m3b {
                display: inline-block;
                width: 26px;
                height: 26px;
                background-image: url(~@/assets/images/icon-m3b.png);
                vertical-align: middle;
            }


            h5{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 2.5em;
                margin-bottom: 16px;
                padding: 0 60px;
                font-size: 28px;
                font-weight: 700;
                color: #7f572d;
            }

            .discount{
                margin-bottom: 10px;
                color: #d33d27;
            }

            .low{
                margin-top: 8px;
                color: #7f572d;

                .p-now{
                    font-size: 28px;
                    font-weight: 700;
                    color: #d33d27;
                }

                .p-before {
                    padding-left: 8px;
                    color: #ad7239;
                    text-decoration: line-through;
                }

            }

            .banner {
                width: 283px;
                height: 39px;
                line-height: 39px;
                margin: 15px auto 0;
                text-align: center;
                color: #683d1e;
                background-image: url(~@/assets/images/shop/bg-shopname.png);
            }

            .u-btn.apply{
                position: absolute;
                left: 50%;
                bottom: 62px;
                transform: translateX(-50%);
                width: 232px;
                height: 89px;
                background-image: url(~@/assets/images/shop/btn-apply.png);
            }
        }
    }

    .goods-detail{
        .goods-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 118px;
            height: 118px;
            margin: 0 auto;
            background-image: url(~@/assets/images/shop/bg-item.png);
        }

        .goods-pic{
            width: 69px;
            height: 69px;
        }
    }    
}
</style>